import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import AnimationSlideTop from "../../Animation/AnimationSlideTop";

import image1 from "../../Assest/Images/Aboutus/image4.jpeg";
import image2 from "../../Assest/Images/Aboutus/image6.jpeg";
import image3 from "../../Assest/Images/Aboutus/image3.jpeg";

function Volunteers() {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <div style={{ overflow: "hidden" }}>
      {/* <Box sx={styles.container}>
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AnimationSlideLeft duration={1.4} rootMargin={"-10px"}>
              <Box sx={{ p: 4 }}>
                <Typography sx={styles.heading}>
                  {translations.volunteer_heading}
                </Typography>
                <Typography sx={styles.subheading}>
                  {translations.volunteer_subheading}
                </Typography>
                <div style={{ display: "flex", justifyContent: "flex-start" }}>
                  <Button
                    // onClick={() => {
                    //   navigate(Routings.VOLUNTEERSADD);
                    //   window.scrollTo({ top: 0, behavior: "auto" });
                    // }}
                    onClick={handleRedirect}
                    type="submit"
                    variant="contained"
                    sx={styles.button}
                  >
                    {translations.volunteer_button}
                  </Button>
                </div>
              </Box>
            </AnimationSlideLeft>
          </Grid>
          <Grid item xs={12} md={6} p={2}>
            <AnimationSlideRight duration={1.4} rootMargin={"-10px"}>
              <Box sx={styles.imageSection}>
                <img
                  src={volunteersImfe}
                  width={isMobile ? "80%" : "100%"}
                  alt="Contact Illustration"
                />
              </Box>
            </AnimationSlideRight>
          </Grid>
        </Grid>
      </Box> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: isMobile ? "20px 10px" : "40px 20px",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: isMobile ? "18px" : "24px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Gallery
          </Typography>
          <Typography
            sx={{
              fontSize: isMobile ? "14px" : "16px",
              width: isMobile ? "90%" : "60%",
              margin: "0 auto",
              padding: "10px 0",
            }}
          >
            Take a peek into our school life — from classrooms to cultural
            events, field trips to festivals. Every photo reflects the joy of
            learning and growing together.
          </Typography>
        </Box>
      </Box>
      <AnimationSlideTop duration={1} rootMargin={"-10px"}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
            gap: "20px",
            marginBottom: "2rem",
          }}
        >
          {/* Top center image */}
          <Box
            component="img"
            src={image1}
            alt="Top Image"
            sx={{
              width: "300px",
              height: "200px",
              borderRadius: "16px",
              objectFit: "cover",
            }}
          />
          <Box
            component="img"
            src={image2}
            alt="Left Middle"
            sx={{
              width: "300px",
              height: "200px",
              borderRadius: "16px",
              objectFit: "cover",
            }}
          />
          <Box
            component="img"
            src={image3}
            alt="Right Middle"
            sx={{
              width: "300px",
              height: "200px",
              borderRadius: "16px",
              objectFit: "cover",
            }}
          />
        </Box>
      </AnimationSlideTop>
    </div>
  );
}

export default Volunteers;
